module.exports = __webpack_public_path__ + "static/media/app_store_badge.6a86c2f2.png";